// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SiteAdmin-FormDefinitionConfig-FormPreview-module-classicFormBanner {
	background-color: var(--cds-grays-gray100);
	height: 50px;
	-ms-flex-pack: end;
	    justify-content: flex-end;
	padding: 10px;
}

.SiteAdmin-FormDefinitionConfig-FormPreview-module-formPreview {
	height: 100vh;
}

.SiteAdmin-FormDefinitionConfig-FormPreview-module-newFormBackground {
	background-color: var(--cds-grays-gray100);
}`, "",{"version":3,"sources":["webpack://./src/SiteAdmin/FormDefinitionConfig/FormPreview.module.css"],"names":[],"mappings":"AAAA;CACC,0CAA0C;CAC1C,YAAY;CACZ,kBAAyB;KAAzB,yBAAyB;CACzB,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;AAC3C","sourcesContent":[".classicFormBanner {\n\tbackground-color: var(--cds-grays-gray100);\n\theight: 50px;\n\tjustify-content: flex-end;\n\tpadding: 10px;\n}\n\n.formPreview {\n\theight: 100vh;\n}\n\n.newFormBackground {\n\tbackground-color: var(--cds-grays-gray100);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"classicFormBanner": `SiteAdmin-FormDefinitionConfig-FormPreview-module-classicFormBanner`,
	"formPreview": `SiteAdmin-FormDefinitionConfig-FormPreview-module-formPreview`,
	"newFormBackground": `SiteAdmin-FormDefinitionConfig-FormPreview-module-newFormBackground`
};
module.exports = ___CSS_LOADER_EXPORT___;
